import { getPostMessageTargetOrigin } from "./common-utils";

const postMessageToParent = (eventName: string, data = {}): void => {
  window.parent.postMessage({ eventName, ...data }, getPostMessageTargetOrigin());
};

export default postMessageToParent;
